import { createContext } from "solid-js";
export const TransitionContext = createContext();
